var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { h, toChildArray } from 'preact';
import { useSlider } from './useSlider';
import styles from './Slider.module.scss';
const ChevronLeft = () => (h("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false" },
    h("path", { d: "M15 18l-6-6 6-6", stroke: "currentColor", "stroke-width": "1.6", "stroke-linecap": "round", "stroke-linejoin": "round" })));
const ChevronRight = () => (h("svg", { width: "16", height: "16", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false" },
    h("path", { d: "M9 6l6 6-6 6", stroke: "currentColor", "stroke-width": "1.6", "stroke-linecap": "round", "stroke-linejoin": "round" })));
/**
 * Reusable horizontal carousel: drag-to-slide (mouse) + native touch pan,
 * with a Frame 689–style progress bar + prev/next control strip underneath.
 *
 * Each child is wrapped in an internal slide container so consumers can
 * render plain elements without worrying about flex/scroll-snap styling:
 *
 *   <Slider>
 *     {products.map(p => <ProductCard key={p.id} product={p} />)}
 *   </Slider>
 *
 * Use the companion `useSlider()` hook directly when you need custom DOM
 * (e.g. non-card content, a different nav layout, or integration into an
 * existing container).
 */
export function Slider(_a) {
    var { children, className, showNav = true, navLabel = 'Carousel navigation', prevLabel = 'Previous', nextLabel = 'Next' } = _a, hookOptions = __rest(_a, ["children", "className", "showNav", "navLabel", "prevLabel", "nextLabel"]);
    const { trackRef, scrollProgress, canScrollPrev, canScrollNext, scrollBy } = useSlider(hookOptions);
    const slides = toChildArray(children);
    return (h("div", { class: `${styles.slider}${className ? ' ' + className : ''}` },
        h("div", { ref: trackRef, class: styles.track }, slides.map((child, i) => {
            var _a;
            // Preserve the caller's key when available so Preact reconciles
            // correctly across reorders.
            const key = (_a = child === null || child === void 0 ? void 0 : child.key) !== null && _a !== void 0 ? _a : i;
            return (h("div", { key: key, class: styles.slide }, child));
        })),
        showNav && slides.length > 0 && (h("nav", { class: styles.nav, "aria-label": navLabel },
            h("div", { class: styles.progress, "aria-hidden": "true" },
                h("span", { class: styles.progressFill, style: { width: `${Math.round(scrollProgress * 100)}%` } })),
            h("div", { class: styles.navButtons },
                h("button", { type: "button", class: styles.navButton, onClick: () => scrollBy(-1), disabled: !canScrollPrev, "aria-label": prevLabel },
                    h(ChevronLeft, null)),
                h("button", { type: "button", class: styles.navButton, onClick: () => scrollBy(1), disabled: !canScrollNext, "aria-label": nextLabel },
                    h(ChevronRight, null)))))));
}
